import { buildStaticUploadsEndpoint } from '../utils/endpoint';

// ----------------------------------------------------------------------

function path(root, sublink) {
  return `${root}${sublink}`;
}

const ROOTS_AUTH = '/auth';
const ROOTS_DASHBOARD = '/dashboard';
const ROOTS_ADMIN_DASHBOARD = '/admin';
const ROOTS_TRAINER_DASHBOARD = '/trainer';
const staticUploadsEndpoint = buildStaticUploadsEndpoint(process.env.REACT_APP_HOST_API_ENDPOINT);

export const IMAGE_URL_STORAGE = {
  horse: `${staticUploadsEndpoint}/`,
};

// ----------------------------------------------------------------------

export const USER_ROLE = {
  trainer: 'Trainer',
  admin: 'Admin',
  owner: 'Owner',
  assistantTrainer: 'AssistantTrainer',
  jockey: 'Jockey',
  salesAgent: 'SalesAgent',
  financeAdmin: 'FinanceAdmin',
};
export const USER_STATUS = {
  approved: 'Approved',
  pending: 'Pending',
};
export const HORSE_STATUS = {
  approved: 'Approved',
};

export const PATH_AUTH = {
  root: ROOTS_AUTH,
  login: path(ROOTS_AUTH, '/login'),
  loginByToken: path(ROOTS_AUTH, '/login-by-token/:accesstoken'),
  register: path(ROOTS_AUTH, '/register'),
  loginUnprotected: path(ROOTS_AUTH, '/login-unprotected'),
  registerUnprotected: path(ROOTS_AUTH, '/register-unprotected'),
  verify: path(ROOTS_AUTH, '/verify'),
  email_verify: path(ROOTS_AUTH, '/email_verify'),
  email_verify_code: path(ROOTS_AUTH, '/email_verify_code'),
  resetPassword: path(ROOTS_AUTH, '/reset-password'),
  newPassword: path(ROOTS_AUTH, '/new-password'),
};

export const PATH_PAGE = {
  comingSoon: '/coming-soon',
  maintenance: '/maintenance',
  pricing: '/pricing',
  payment: '/payment',
  about: '/about-us',
  contact: '/contact-us',
  faqs: '/faqs',
  tutorials: '/tutorials',
  privacy: '/privacy-policy',
  terms: '/terms-conditions',
  page403: '/403',
  page404: '/404',
  page500: '/500',
  components: '/components',
  download: {
    ios: 'https://apps.apple.com/',
    android: 'https://play.google.com/',
  },
};

export const PATH_ADMIN_DASHBOARD = {
  root: ROOTS_ADMIN_DASHBOARD,
  app: path(ROOTS_ADMIN_DASHBOARD, '/app'),

  product: {
    list: path(ROOTS_ADMIN_DASHBOARD, '/product/list'),
  },

  subscription: {
    list: path(ROOTS_ADMIN_DASHBOARD, '/subscription/list'),
  },

  order: {
    list: path(ROOTS_ADMIN_DASHBOARD, '/order/list'),
  },

  coupon: {
    list: path(ROOTS_ADMIN_DASHBOARD, '/coupon/list'),
  },

  horse: {
    list: path(ROOTS_ADMIN_DASHBOARD, '/horse/list'),
    create: path(ROOTS_ADMIN_DASHBOARD, '/horse/create'),
    edit: path(ROOTS_ADMIN_DASHBOARD, '/horse/edit/:horseId'),
    ownerships_approved: path(ROOTS_ADMIN_DASHBOARD, '/horse/ownerships_approved'),
    ownerships_pending: path(ROOTS_ADMIN_DASHBOARD, '/horse/ownerships_pending'),
  },

  workout: {
    list: path(ROOTS_ADMIN_DASHBOARD, '/workout/list'),
    details: path(ROOTS_ADMIN_DASHBOARD, '/workout/performance/:id'),
    workout_details: path(ROOTS_ADMIN_DASHBOARD, '/workout/single_workout'),
  },

  track: {
    list: path(ROOTS_ADMIN_DASHBOARD, '/track/list'),
    create: path(ROOTS_ADMIN_DASHBOARD, '/track/create'),
  },

  promo: {
    list: path(ROOTS_ADMIN_DASHBOARD, '/promo/list'),
    create: path(ROOTS_ADMIN_DASHBOARD, '/promo/create'),
  },

  metastrider: {
    list: path(ROOTS_ADMIN_DASHBOARD, '/metastrider/list'),
  },

  general: {
    app: path(ROOTS_ADMIN_DASHBOARD, '/app'),
  },

  user: {
    root: path(ROOTS_ADMIN_DASHBOARD, '/user'),
    list: path(ROOTS_ADMIN_DASHBOARD, '/user/list'),
    account: path(ROOTS_ADMIN_DASHBOARD, '/user/account'),
  },

  notification: {
    list: path(ROOTS_ADMIN_DASHBOARD, '/notification/list'),
  },

  subscriptions: {
    list: path(ROOTS_ADMIN_DASHBOARD, '/subscriptions/list'),
  },

  dataManager: {
    root: path(ROOTS_ADMIN_DASHBOARD, '/data-manager'),
  },
};

export const PATH_TRAINER_DASHBOARD = {
  // '/trainer/dashboard'
  root: ROOTS_TRAINER_DASHBOARD,
  app: path(ROOTS_TRAINER_DASHBOARD, '/app'),

  horse: {
    list: path(ROOTS_TRAINER_DASHBOARD, '/horse/list'),
    create: path(ROOTS_TRAINER_DASHBOARD, '/horse/create'),
  },
  ecommerce: {
    list: path(ROOTS_TRAINER_DASHBOARD, '/shop'),
    product: path(ROOTS_TRAINER_DASHBOARD, '/detail'),
    subscription: path(ROOTS_TRAINER_DASHBOARD, '/subscription'),
    subscriptiondetail: path(ROOTS_TRAINER_DASHBOARD, '/subscriptiondetail'),
    checkout: path(ROOTS_TRAINER_DASHBOARD, '/checkout'),
  },
  workout: {
    list: path(ROOTS_TRAINER_DASHBOARD, '/workout/list'),
    details: path(ROOTS_TRAINER_DASHBOARD, '/workout/performance/:id'),
    workout_details: path(ROOTS_TRAINER_DASHBOARD, '/workout/:id'),
  },
  order: {
    list: path(ROOTS_TRAINER_DASHBOARD, '/order/list'),
  },
  subscription: {
    list: path(ROOTS_TRAINER_DASHBOARD, '/subscription/list'),
  },
  general: {
    app: path(ROOTS_TRAINER_DASHBOARD, '/app'),
  },

  user: {
    root: path(ROOTS_TRAINER_DASHBOARD, '/user'),
    account: path(ROOTS_TRAINER_DASHBOARD, '/user/account'),
  },
};

export const PATH_DASHBOARD = {
  root: ROOTS_DASHBOARD,

  horse: {
    myhorses: path(ROOTS_DASHBOARD, '/horse/myhorses'),
    list: path(ROOTS_DASHBOARD, '/horse/list'),
  },
  track: {
    list: path(ROOTS_DASHBOARD, '/track/list'),
  },
  workout: {
    list: path(ROOTS_DASHBOARD, '/workout/list'),
    details: path(ROOTS_DASHBOARD, '/workout/performance/:id'),
    workout_details: path(ROOTS_DASHBOARD, '/workout/single_workout/:id'),
  },
  trainers: {
    list: path(ROOTS_DASHBOARD, '/trainers/list'),
  },
  general: {
    app: path(ROOTS_DASHBOARD, '/app'),
  },
  ecommerce: {
    list: path(ROOTS_DASHBOARD, '/shop'),
    product: path(ROOTS_DASHBOARD, '/detail'),
    subscription: path(ROOTS_DASHBOARD, '/subscription'),
    subscriptiondetail: path(ROOTS_DASHBOARD, '/subscriptiondetail'),
    checkout: path(ROOTS_DASHBOARD, '/checkout'),
    catalogRoot: path(ROOTS_DASHBOARD, '/e-commerce'),
    catalogList: path(ROOTS_DASHBOARD, '/e-commerce/list'),
    catalogNew: path(ROOTS_DASHBOARD, '/e-commerce/product/new'),
    catalogView: path(ROOTS_DASHBOARD, '/e-commerce/product/:name'),
    catalogEdit: path(ROOTS_DASHBOARD, '/e-commerce/product/:name/edit'),
  },
  order: {
    list: path(ROOTS_DASHBOARD, '/order/list'),
  },
  subscription: {
    list: path(ROOTS_DASHBOARD, '/subscription/list'),
  },

  user: {
    root: path(ROOTS_DASHBOARD, '/user'),
    account: path(ROOTS_DASHBOARD, '/user/account'),
  },
};

export const PATH_DOCS = {
  root: 'https://docs.minimals.cc',
  changelog: 'https://docs.minimals.cc/changelog',
};

export const PATH_ZONE_ON_STORE = 'https://mui.com/store/items/zone-landing-page/';

export const PATH_MINIMAL_ON_STORE = '/dashboard/';

export const PATH_FREE_VERSION = 'https://mui.com/store/items/minimal-dashboard-free/';

export const PATH_FIGMA_PREVIEW =
  'https://www.figma.com/file/rWMDOkMZYw2VpTdNuBBCvN/%5BPreview%5D-Minimal-Web.26.11.22?node-id=0%3A1&t=ya2mDFiuhTXXLLF1-1';
